import { Component, Input, OnChanges } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { Portfolio } from 'src/app/features/portfolio/portfolio.model'
import { CHART_COLOR_CODE } from 'src/app/features/shared/constants/chart-color-codes'
import { Asset } from 'src/app/models/allocation-response.model'

@Component({
  selector: 'app-asset-allocation-chart',
  templateUrl: './asset-allocation-chart.component.html',
  styleUrls: ['./asset-allocation-chart.component.scss'],
})
export class AssetAllocationChartComponent implements OnChanges {
  @Input() portfolioModel: Portfolio
  @Input() chartData: Asset
  @Input() fundId: string

  //chart
  chartId = 'assetAllocationPieChart1'
  tableId = 'assetAllocationTable1'
  dataSource: MatTableDataSource<any>
  displayedColumns = ['allocationByColor', 'name', 'value']
  chartAndTable = []
  assetData = []
  bond = ''
  stock = ''
  shortTerm = ''
  asOfDate: string
  others = ''
  alternatives = ''
  colorIndex = 0
  selectPathData = undefined

  constructor() {
    // do nothing.
  }

  getColorCode(index) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (index > 4) {
      this.colorIndex = 0
    } else {
      this.colorIndex = index
    }
    return CHART_COLOR_CODE.color[this.colorIndex]
  }

  selectPath(rowId) {
    this.selectPathData = {
      chartId: this.chartId,
      tableId: this.tableId,
      trId: rowId,
    }
  }

  ngOnChanges() {
    this.getChartData()
  }

  getChartData() {
    if (this.chartData !== null) {
      this.asOfDate = this.chartData.asOfDate
      this.bond = this.chartData.bonds
      this.stock = this.chartData.stocks
      this.shortTerm = this.chartData.shortTermReserves
      this.others = this.chartData.others
      this.alternatives = this.chartData.alternatives
      this.assetData = [
        {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          id: 0,
          name: 'Stock',
          value: this.stock,
          color: this.getColorCode(0),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          id: 1,
          name: 'Bond',
          value: this.bond,
          color: this.getColorCode(1),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          id: 2,
          name: 'Short term reserves',
          value: this.shortTerm,
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          color: this.getColorCode(2),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          id: 3,
          name: 'Commodities',
          value: this.others,
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          color: this.getColorCode(3),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          id: 4,
          name: 'Alternatives',
          value: this.alternatives,
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
          color: this.getColorCode(4),
        },
      ].filter((data) => {
        if (data.value !== '0.00') {
          return true
        }
        return false
      })
      this.chartAndTable = []
      this.chartAndTable = [...this.assetData]
      this.dataSource = new MatTableDataSource(this.chartAndTable)
      this.selectPathData = {
        chartId: this.chartId,
        tableId: this.tableId,
        trId: 1,
      }
    }
  }
  ngOnInit() {
    // do nothing.
  }
}
